module.exports = __webpack_public_path__ + "img/goods3_bg.850af51f.png";